import type { JSX } from "react";
import type { AuthStatus } from "../types";
import { LoadingStateScreen } from "./LoadingStateScreen";

export interface AuthScreenProps {
  status: AuthStatus;
  message: string;
  onRetry?: () => void;
}

export function AuthScreen({ status, message, onRetry }: AuthScreenProps): JSX.Element {
  const isError = status === "error";

  return (
    <LoadingStateScreen
      stateAttribute="data-platform-auth-state"
      authStatus={status}
      showProgress={!isError}
      title="Authenticating…"
      message={message}
      actionLabel={isError ? "Try Again" : undefined}
      onAction={isError ? onRetry : undefined}
    />
  );
}
